import { render, staticRenderFns } from "./DisplaySchools.vue?vue&type=template&id=3aad4cfa&scoped=true&"
import script from "./DisplaySchools.vue?vue&type=script&lang=ts&"
export * from "./DisplaySchools.vue?vue&type=script&lang=ts&"
import style0 from "./DisplaySchools.vue?vue&type=style&index=0&id=3aad4cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad4cfa",
  null
  
)

export default component.exports